import { render, staticRenderFns } from "./CompleteOrderMobile.vue?vue&type=template&id=059f16f9"
import script from "./CompleteOrderMobile.vue?vue&type=script&lang=js"
export * from "./CompleteOrderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports